import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-elements-box5',
    templateUrl: './elements-box5.component.html',
    styleUrls: ['./elements-box5.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ElementsBox5Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
